import { useFieldArray, useForm } from "react-hook-form";
import { CategoryModal } from "../CategoryGrid";
import * as React from "react";
import { businessTravelTransport, renderOptions } from "../Category/helpers";
import { FormSelect, NumericFormInput } from "../../../../../../components/Forms";
import { useTranslation } from "react-i18next";
import { VALIDATION_PATTERNS } from "../../../../../Decarbonization/helpers";

function BusinessTravelModalWrapper({ tabKey, modalData, attributesOrder, isOpen, onClose, onSubmit, getEmptyRow }) {
  const { fieldArrayName, editData } = modalData;
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope3"
  });
  const { t: globalTranslation } = useTranslation("translation");

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch
  } = useForm({
    defaultValues: {
      [fieldArrayName]: [editData ? editData : getEmptyRow()]
    }
  });

  const { fields, append, remove, update: updateItem } = useFieldArray({
    control,
    name: fieldArrayName
  });

  const watchFieldArray = watch(fieldArrayName);

  const mapRow = (row, index) => {
    const gridItems = [];
    const modeOfTransportSelector = register(`${fieldArrayName}.${index}.modeOfTransport`, {
      required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.modeOfTransport`) })
    });

    gridItems.push(
      <FormSelect
        errors={errors}
        {...modeOfTransportSelector}
        onChange={(e) => {
          modeOfTransportSelector.onChange(e);
          updateItem(index, { ...watchFieldArray[index], transportSubtype: "" });
        }}
        placeholder=" "
        title={watchFieldArray[index].modeOfTransport !== "" ?
          t(`inputs.modeOfTransportOptions.${watchFieldArray[index].modeOfTransport}`) : ""}
      >
        {renderOptions(businessTravelTransport.map(el => el.mode),
          "organizationQuestionnaire.scope3.inputs.modeOfTransportOptions")}
      </FormSelect>
    );

    gridItems.push(
      <FormSelect
        errors={errors}
        {...register(`${fieldArrayName}.${index}.transportSubtype`, {
          required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.transportSubtype`) })
        })}
        placeholder=" "
        title={watchFieldArray[index].transportSubtype !== "" ?
          t(`inputs.transportSubtypeOptions.${watchFieldArray[index].modeOfTransport}.${watchFieldArray[index].transportSubtype}`) : ""}
      >
        {renderOptions(businessTravelTransport.find(el => el.mode === watchFieldArray[index].modeOfTransport)?.subtypes ?? [],
          `organizationQuestionnaire.scope3.inputs.transportSubtypeOptions.${watchFieldArray[index].modeOfTransport}`)}
      </FormSelect>
    );

    gridItems.push(
      <NumericFormInput
        errors={errors}
        type="number"
        {...register(`${fieldArrayName}.${index}.distanceTravelled`, {
          required: globalTranslation("entityRequired", { entityName: t(`inputs.${tabKey}.distanceTravelled`) }),
          pattern: VALIDATION_PATTERNS.POSITIVE_NUMBER
        })}
      />
    );

    return gridItems;
  };

  return (
    <CategoryModal
      modalData={modalData}
      formData={{ handleSubmit, fields, append, remove }}
      attributesOrder={attributesOrder}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      getEmptyRow={getEmptyRow}
      mapRow={mapRow}
    />
  );

}

export default BusinessTravelModalWrapper;